var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConvert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".f{fill:url(#e);}.g{fill:url(#d);}.h{fill:url(#c);}.i{fill:url(#b);}.j{opacity:.59;stroke:#9ecfef;stroke-width:11.58px;}.j,.k,.l,.m{mix-blend-mode:multiply;}.j,.n{fill:none;stroke-miterlimit:10;}.o{fill:#fff;}.p{fill:#ffecb2;}.q{fill:#92ceef;}.r{fill:#c6e3f7;}.s{fill:#c5e9fa;}.t{fill:#a2dada;}.u{fill:#295da8;}.v{fill:#73c2eb;}.k{fill:#9ecfef;}.l{fill:#b8e4f8;}.n{stroke:#c5e9fa;}.w{opacity:.79;}.w,.x{mix-blend-mode:screen;}.x{opacity:.89;}.y{isolation:isolate;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 83.02,
    y1: 169.11,
    x2: 209.11,
    y2: 116.86,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#17529f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#009dda"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 206.89,
    y1: 285.14,
    x2: 342.52,
    y2: 285.14,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#008ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0875bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1353a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 427.34,
    y1: 101.2,
    x2: 383.27,
    y2: 31.91,
    gradientTransform: "translate(-101.71 187.61) rotate(-19.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#dff1f9",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#90d0ec",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#119bd7",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0094d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0596d5",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#6fc2e7",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#bce3f4",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#ecf7fb",
    stopOpacity: 0.07
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 533.21,
    y1: 173.99,
    x2: 485.32,
    y2: 98.7,
    gradientTransform: "translate(173.47 -225.12) rotate(111.13) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdfefe",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a4d9f0",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#5dbbe4",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#2aa6dc",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#0b98d6",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#0094d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#0797d6",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#1b9fd9",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#3daddf",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#6cc1e6",
    stopOpacity: 0.57
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#a9dbf0",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f2f9fc",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "y"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "r",
    cx: 206.89,
    cy: 204.79,
    r: 152.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M206.89,44.09V204.78H46.19c0-88.74,71.93-160.7,160.7-160.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M367.58,204.78c0,88.76-71.93,160.72-160.7,160.72V204.78h160.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 206.89,
    cy: 204.79,
    r: 138
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 155.23,
    cy: 153.12,
    r: 28.24
  }), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 198.94,
    cy: 212.77,
    r: 3.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 214.83,
    cy: 196.86,
    r: 3.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "o",
    cx: 258.55,
    cy: 256.45,
    r: 28.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M172.09,142.7v3.04c0,3.56-2.88,6.44-6.44,6.44h-24.83c-1.36,0-2.46-1.1-2.46-2.46v-1.3h27.29c1.48,0,2.68-1.2,2.68-2.68v-3.04c0-1.48-1.2-2.68-2.68-2.68h-18.61v2.32h17.53v2.24c0,.84-.68,1.52-1.52,1.52h-15.79c-2.2,0-3.98-1.78-3.98-3.98v-5.86h22.37c3.56,0,6.44,2.88,6.44,6.44Zm0,20.85v-3.04c0-3.56-2.88-6.44-6.44-6.44h-24.83c-1.36,0-2.46,1.1-2.46,2.46v1.3h27.29c1.48,0,2.68,1.2,2.68,2.68v3.04c0,1.48-1.2,2.68-2.68,2.68h-18.61v-2.32h17.53v-2.24c0-.84-.68-1.52-1.52-1.52h-15.79c-2.2,0-3.98,1.78-3.98,3.98v5.86h22.37c3.56,0,6.44-2.88,6.44-6.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M266.73,237.93c.64,.26,1.15,.66,1.28,1.38,.05,.27,.03,.55,.05,.86,.59,0,1.17-.02,1.74,0,.78,.03,1.42,.6,1.57,1.36,.15,.77-.23,1.54-.95,1.84-.28,.11-.61,.15-.91,.16-.47,.03-.94,0-1.47,0,0,.19,0,.35,0,.52,0,7.42,0,14.85,0,22.27,0,.75-.24,1.35-.93,1.7-1.04,.55-2.31-.14-2.42-1.32-.04-.43,0-.86,0-1.38-2.79,2.42-5.91,3.35-9.43,2.67-2.45-.47-4.47-1.73-6.08-3.64-3.27-3.89-3.26-9.83,.03-13.64,1.98-2.28,4.46-3.59,7.49-3.78,3.03-.2,5.65,.8,7.95,2.82v-6.22c-.52,0-1.02,0-1.53,0-.89-.02-1.53-.46-1.74-1.19-.31-1.06,.43-2.12,1.54-2.17,.56-.03,1.13,0,1.75,0-.11-1.09,.27-1.88,1.33-2.25h.72Zm-2.06,19.64c.01-4-3.27-7.28-7.28-7.29-4.01,0-7.27,3.23-7.29,7.24-.02,4.03,3.24,7.31,7.28,7.32,4.01,0,7.28-3.25,7.3-7.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M257.36,274.96c-2.95,0-5.9,0-8.85,0-.96,0-1.63-.56-1.76-1.47-.13-.89,.52-1.77,1.41-1.86,.57-.05,1.15-.04,1.73-.04,5.4,0,10.79,0,16.19,0,.56,0,1.09,.09,1.49,.52,.49,.53,.61,1.14,.35,1.8-.28,.7-.84,1.04-1.58,1.05-1.67,.01-3.35,0-5.02,0-1.31,0-2.63,0-3.94,0h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M90.78,204.79c0-64.12,51.98-116.11,116.11-116.11"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M206.89,326.68c-46.16-.93-89.9-30.74-107.13-73.46-5.75-13.84-8.74-28.7-8.88-43.49,1.1,14.76,5.04,29.2,11.51,42.3,18.79,39.1,61.23,65,104.49,63.08v11.58h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M322.99,204.79c0,64.12-51.98,116.11-116.11,116.11"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M206.89,82.89c46.4,.92,90.34,31.04,107.41,74.08,5.7,13.94,8.6,28.9,8.63,43.77-1-14.84-4.85-29.38-11.28-42.59-18.65-39.41-61.28-65.61-104.76-63.68v-11.58h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "90.88 209.73 88.41 218.61 91.64 216.2 95.34 217.8 90.88 209.73"
  })), /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "v",
    points: "322.98 200.77 325.78 191.98 322.46 194.28 318.82 192.54 322.98 200.77"
  })), /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M340.21,155.32l-9.72,3.39c-5.88-16.05-15.03-31.07-26.56-43.55-11.5-12.49-25.72-22.86-41.21-30.07l4.19-9.4c16.76,7.78,32.14,18.99,44.59,32.5,12.47,13.5,22.37,29.76,28.7,47.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "x"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M155.98,340.8l4.06-10.42c-17.2-7.01-33.15-17.54-46.25-30.55-13.12-12.98-23.81-28.83-31.04-45.93l-10.38,4.18c7.79,18.51,19.36,35.65,33.55,49.7,14.17,14.08,31.44,25.46,50.05,33.02Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "s",
    cx: 68.88,
    cy: 342.92,
    r: 15.57
  }), /*#__PURE__*/React.createElement("circle", {
    className: "n",
    cx: 68.88,
    cy: 342.92,
    r: 22.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "t",
    cx: 314.37,
    cy: 44.09,
    r: 11.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "p",
    cx: 76.21,
    cy: 75.69,
    r: 7.33
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConvert);
export default __webpack_public_path__ + "static/media/iconConvert.d6b337d03370f5d6cb9a6393f07749e5.svg";
export { ForwardRef as ReactComponent };